<!-- Password Expiry Warning Banner -->
@if (shouldShow()) {
<div
  class="w-full bg-amber-100 border-b border-amber-500 py-3 px-4 z-50 dark:bg-amber-900 dark:border-amber-700 print:hidden"
  role="alert"
  aria-live="polite"
  aria-atomic="true">
  <div class="max-w-screen-xl mx-auto flex items-center gap-4 sm:gap-6">
    <!-- Icon -->
    <div class="flex items-center shrink-0 text-amber-500 dark:text-amber-400">
      <mat-icon
        class="w-6 h-6 text-yellow-500"
        [svgIcon]="'heroicons_solid:exclamation-triangle'"></mat-icon>
    </div>

    <!-- Message -->
    <div class="flex-1 flex flex-col gap-[0.125rem] min-w-0 min-[650px]:gap-1">
      <span class="font-semibold text-sm leading-5 text-amber-800 dark:text-amber-200">
        Password Expiring Soon
      </span>
      <span
        class="text-sm leading-5 text-amber-900">
        {{ message() }}
      </span>
    </div>

    <!-- Action Button -->
    <button
      mat-flat-button
      color="warn"
      class="shrink-0 text-sm min-w-0 px-4 max-[650px]:hidden focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-600"
      (click)="changePassword()"
      aria-label="Change password now">
      Change Password
    </button>

    <!-- Dismiss Button -->
    <button
      mat-icon-button
      class="shrink-0  text-amber-800 dark:text-amber-200 hover:bg-amber-400 dark:hover:bg-amber-800 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-600"
      (click)="dismiss()"
      aria-label="Dismiss password expiry warning">
      <mat-icon class="max-[650px]:!min-w-4 max-[650px]:!w-4 max-[650px]:!h-4" [svgIcon]="'heroicons_outline:x-mark'"></mat-icon>
    </button>
  </div>
   <!-- Action Button -->
  <div class="min-[650px]:hidden flex items-center justify-center mt-2">
   <button
   mat-flat-button
   color="warn"
   class="text-sm min-w-0 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-600"
   (click)="changePassword()"
   aria-label="Change password now">
   Change Password
 </button>
  </div>
</div>
}
